import { render } from "./ReferenceRecordPage.vue?vue&type=template&id=103e0fc4&scoped=true"
import script from "./ReferenceRecordPage.vue?vue&type=script&lang=js"
export * from "./ReferenceRecordPage.vue?vue&type=script&lang=js"

import "./ReferenceRecordPage.vue?vue&type=style&index=0&id=103e0fc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-103e0fc4"]])

export default __exports__